import {backend} from '../backend'
import {handleRes} from './handle_res'
import {getParams} from './helpers'
import {backendKind} from '../record_building/record_keys'

export async function attach(kind, id, data) {
	const url = `${kind}/${id}/attachment`
	const res = await upload(data, {url})
	return handleRes(res, kind)
}

export async function removeAttachment(kind, id, idx) {
	const sanitizedKind = backendKind(kind)
	const params = getParams(sanitizedKind, {index: idx})
	const url = `${sanitizedKind}/${id}/remove_attachment`
	const res = await backend.post(url, params)
	return handleRes(res, sanitizedKind)
}

export async function updateAsset(kind, id, data, {doLoad = true} = {}) {
	const url = `${kind}/${id}`

	const res = await upload(data, {
		method: 'put',
		paramName: 'info[pdf_content]',
		url,
		doLoad,
	})
	return handleRes(res, kind)
}

const makeFileData = (data, paramName) => {
	const formData = new FormData()
	formData.append(paramName, data)
	return formData
}

const handleProgress = ({loaded = 0, total = 0}) => {
	const tot = (loaded / total) * 100
	return Math.round(tot || 0)
}

const upload = async (data, {method = 'post', paramName = 'file', doLoad, setProgress, url} = {}) => {
	if (!data || !data.length) return
	const files = Array.from(data)
	const file = files[0] // only signle upload now
	const fileData = makeFileData(file, paramName)
	const func = method == 'post' ? backend.post : backend.put

	const condHeaders = {}
	if (doLoad) condHeaders['doLoad'] = true

	return func(url, fileData, {
		onUploadProgress: info => setProgress?.(handleProgress(info)),
		headers: {
			...condHeaders,
			Accept: 'application/json',
			'Content-Type': 'multipart/form-data',
		},
	})
}
